import React from 'react';
import { Button, Col, ControlLabel, Form, FormGroup, FormControl, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import map from 'lodash/map';
import { I18N, RUN_STATUSES } from '../../../constants';

export default class RunSearch extends React.Component {
    render() {
        const {
            search,
            isFetching = false,
            handleChange,
            handleDateChange,
            handleSubmit,
            handleReset,
        } = this.props;

        return (
            <Form horizontal onSubmit={handleSubmit}>
                <Row style={{ marginBottom: 5 }}>
                    <Col sm={4} className="no-gutter">
                        <FormGroup controlId="routeCode">
                            <Col componentClass={ControlLabel} sm={5}>
                                Route code
                            </Col>
                            <Col sm={6}>
                                <FormControl
                                    type="text"
                                    maxLength="1000"
                                    name="routeCode"
                                    value={search.routeCode}
                                    placeholder="..."
                                    onChange={handleChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="runDate">
                            <Col componentClass={ControlLabel} sm={5}>
                                Run date
                            </Col>
                            <Col sm={6}>
                                <Datetime
                                    name="runDate"
                                    value={search.runDate}
                                    onChange={handleDateChange}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat={false}
                                    inputProps={{
                                        maxLength: 255,
                                        placeholder: '...',
                                    }}
                                    closeOnSelect
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm={4} className="no-gutter">
                        <FormGroup controlId="runSequence">
                            <Col componentClass={ControlLabel} sm={5}>
                                Run sequence
                            </Col>
                            <Col sm={6}>
                                <FormControl
                                    type="text"
                                    maxLength="1000"
                                    name="runSequence"
                                    value={search.runSequence}
                                    placeholder="..."
                                    onChange={handleChange}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="logisticPartner">
                            <Col componentClass={ControlLabel} sm={5}>
                                Logistic partner
                            </Col>
                            <Col sm={6}>
                                <FormControl
                                    type="text"
                                    maxLength="1000"
                                    name="logisticPartner"
                                    value={search.logisticPartner}
                                    placeholder="..."
                                    onChange={handleChange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm={4} className="no-gutter">
                        <FormGroup controlId="runStatus">
                            <Col componentClass={ControlLabel} sm={5}>
                                Run status
                            </Col>
                            <Col sm={6}>
                                <FormControl
                                    componentClass="select"
                                    name="runStatus"
                                    value={search.runStatus}
                                    onChange={handleChange}
                                >
                                    <option value="">...</option>
                                    {map(RUN_STATUSES, a => (
                                        <option key={a} value={a}>
                                            {I18N.RUN_STATUS[a]}
                                        </option>
                                    ))}
                                </FormControl>
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="submitButton">
                            <Col sm={6} smOffset={5}>
                                <Button
                                    type="submit"
                                    style={{ width: '100%' }}
                                    bsStyle="primary"
                                    disabled={isFetching}
                                >
                                    {isFetching ? 'Searching...' : 'Search'}
                                </Button>
                            </Col>
                        </FormGroup>
                        <FormGroup controlId="resetButton">
                            <Col sm={6} smOffset={5}>
                                <Button
                                    type="reset"
                                    style={{ width: '100%' }}
                                    disabled={isFetching}
                                    onClick={handleReset}
                                >
                                    Reset
                                </Button>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }
}
